<input
  class="check-box"
  type="checkbox"
  [id]="id"
  [formControl]="inputFormControl"
  (change)="onCheckBoxSelect($event)"
/>
<label class="check-box-text" [for]="id" *ngIf="showLabel">{{ labelName }}</label>
